import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'datex'
})

// This is only used to fix the ng2 Date pipe bug for IE/Edge
// open issue here: https://github.com/angular/angular/issues/9524
// temp fix here:
// https://stackoverflow.com/questions/39728481/angular2-date-pipe-does-not-work-in-ie-11-and-edge-13-14

export class DatexPipe implements PipeTransform {
    transform(value: any, format: string = ""): string {
        // Try and parse the passed value.
        var momentDate = moment(value);

        // If moment didn't understand the value, return it unformatted.
        if (!momentDate.isValid()) return value;

        // Otherwise, return the date formatted as requested.
        return momentDate.format(format);
    }
}


// WEBPACK FOOTER //
// ./~/@c4/sysman/src/app/pipes/datex.pipe.ts